import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ProductOrchestratorService } from '../+products/product-orchestrator.service';
import { VeteranService } from '../+products/veteran/veteran.service';
import { AppInsightsService } from '../app-insights/appinsights.service';
import { InterviewProductDataProviderService } from './abstract-interview-product-data-provider.service';




@Injectable()
export class InterviewVeteranDataProviderService extends InterviewProductDataProviderService {

    constructor(store: Store,
        veteranService: VeteranService,
        productOrchestratorService: ProductOrchestratorService,
        appInsightsService: AppInsightsService
    ) {
        super(store, veteranService, productOrchestratorService, appInsightsService);
    }

}
